export default "<div *ngIf=\"title\" class=\"title\">{{title | titlecase}}</div>\n<div *ngIf=\"titleWithoutCase\" class=\"title\">{{titleWithoutCase}}</div>\n";